<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        区域进出统计明细表
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        ref="formExtend"
        label-width="105"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="timeRange">
            <el-date-picker
              v-model="timeRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.areaIdList">
            <e6Select
              :dataList="areaList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              :disabledNoCheck="false"
              multiple
              ref="areaTreeSelect"
              :placeholder="'区域'"
              @multipleSelect="selArea"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.alarmNameType">
            <e6Select
              :dataList="vehicleList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              :disabledNoCheck="false"
              multiple
              ref="vehicleTreeSelect"
              :placeholder="'车辆'"
              @multipleSelect="selVehicle"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.transType">
            <dict-select
              style="width:230px"
              v-model="slotForms.forms.transType"
              placeholder="请选择运输类型"
              :pkey="'trans_type'"
              :multiple="true"
            ></dict-select>
          </el-form-item>
          <el-form-item label="停留时长(分钟)">
            <el-form-item prop="forms.stayLengthStart">
              <el-input
                placeholder="请输入≥15的数字"
                v-model="slotForms.forms.stayLengthStart"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.stayLengthEnd" label="至">
              <el-input
                placeholder="请输入≤1440的数字"
                v-model="slotForms.forms.stayLengthEnd"
                clearable
              ></el-input>
            </el-form-item>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="170"
          align="center"
          :prop="item.name"
          :label="item.title"
        >
          <template slot-scope="{ row }">
            <div v-if="item.name == 'areaTime'">
              {{row[item.name] && convertTimeFormat(row[item.name])}}
            </div>
            <div v-else>
              {{ row[item.name] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import {
  exportVehicleInOutDetail,
  FetchVehicleInOutDetailByPage
} from "@/api/report/vehicle";
import { FetchVehicleTree } from "@/api/base/vehicle";
import { getAreaDataTree } from "@/api/systemSetting/inOutAreaAnalyzeExport";
import { FetchGetTableColumnSettings } from "_private/api/public.js";

import { mapActions } from "vuex";
import listInit from "@/mixins/listInit";

import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";
export default {
  mixins: [listInit, operationManage],
  name: "inOutAreaDetailList",
  data() {
    return {
      dataType: "object",
      isSearch: false,
      vehicleList: [], // 车辆下拉数据源
      areaList: [],
      timeRange: [
        moment()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ],
      formExtend: {
        forms: {
          beginTime: "",
          endTime: "",
          vehicleIdList: [],
          areaIdList: [],
          transType: [],
          stayLengthStart: "", //停留开始时长
          stayLengthEnd: "" //停留结束时长
        },
        extends: []
      },

      formsExtend: [],
      tableData: [],
      // 表格列相关
      columSetVisible: false,
      multipleSelection: [],
      datePickerOptions: datePickerOptionsNotContainToday,
      // 请求表格数据
      tableDataUrl: "/report/ReportPassAreaPointP/findByPage",
      //导出URL
      exportUrl: "/report/ReportPassAreaPointP/exportList?"
    };
  },

  created() {
    let beginTime = moment()
      .subtract(1, "day")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    let endTime = moment()
      .subtract(1, "day")
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.formExtend.forms.beginTime = beginTime;
    this.formExtend.forms.endTime = endTime;
    if (this.$route.query.areaIdList) {
      this.formExtend.forms.areaIdList = [this.$route.query.areaIdList];
      if (
        this.$route.query.vehicleIdList &&
        this.$route.query.vehicleIdList.length
      ) {
        this.formExtend.forms.vehicleIdList = (
          this.$route.query.vehicleIdList + ""
        ).split(",");
      }
      if (this.$route.query.transType) {
        this.formExtend.forms.transType = this.$route.query.transType.map(v =>
          Number(v)
        );
      }
      this.timeRange = [
        this.$route.query.beginTime || beginTime,
        this.$route.query.endTime || endTime
      ];
    }
    this.initPage();
    // 获取车辆下拉
    this.getVehicleList();
    this.getAreaList();
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    convertTimeFormat(timeStr) {
      // 提取小时和分钟
      const hourMatch = timeStr.match(/(\d+)小时/);
      const minuteMatch = timeStr.match(/(\d+)分/);
      const secondsMatch = timeStr.match(/(\d+)秒/);

      const hours = hourMatch ? parseInt(hourMatch[1]) : 0;
      const minutes = minuteMatch ? parseInt(minuteMatch[1]) : 0;
      const seconds = secondsMatch ? parseInt(secondsMatch[1]) : 0;

      // 格式化小时和分钟为两位数，并添加秒数
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    },
    // 检验时间40天
    validataTime() {
      let start = moment(this.timeRange[0]);
      let end = moment(this.timeRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    // 校验停留时长
    validataStayLength() {
      let start = this.formExtend.forms.stayLengthStart;
      let end = this.formExtend.forms.stayLengthEnd;
      if (start === "" && end === "") {
        return true;
      } else if (start !== "" && end === "") {
        if (/[^\d]/g.test(start)) {
          this.$message.warning("停留时长只能输入数字");
          return false;
        } else if (parseInt(start) < 15) {
          this.$message.warning("停留开始时长必须不小于15分钟");
          return false;
        } else {
          return true;
        }
      } else if (start === "" && end !== "") {
        if (/[^\d]/g.test(end)) {
          this.$message.warning("停留时长只能输入数字");
          return false;
        } else if (parseInt(end) > 1440) {
          this.$message.warning("停留结束时长必须不大于1440分钟");
          return false;
        } else {
          return true;
        }
      } else if (start !== "" && end !== "") {
        if (/[^\d]/g.test(start) || /[^\d]/g.test(end)) {
          this.$message.warning("停留时长只能输入数字");
          return false;
        } else if (parseInt(start) < 15) {
          this.$message.warning("停留开始时长必须不小于15分钟");
          return false;
        } else if (parseInt(end) > 1440) {
          this.$message.warning("停留结束时长必须不大于1440分钟");
          return false;
        } else if (parseInt(start) > parseInt(end)) {
          this.$message.warning("开始时间必须小于结束时间");
          return false;
        } else {
          return true;
        }
      }
    },
    //初始化页面赋值
    async initPage() {
      try {
        this.tableLoading = true;
        let [cols, tableData] = await Promise.all([
          FetchGetTableColumnSettings({
            moduleId: this.moduleId,
            userId: this.userId
          }),
          this.getTableData(this.mergeObj())
        ]);
        /// 设置表格列数据
        this.setTableColumn(cols);
        // 设置表格内容数据
        this.setTableData(tableData);
      } catch (error) {
        console.log(error);
      } finally {
        this.tableLoading = false;
      }
    },
    // 获取车辆下拉
    async getVehicleList() {
      try {
        let res = await FetchVehicleTree();
        if (res.result && Array.isArray(res.result)) {
          this.vehicleList = res.result;
          this.$nextTick(() => {
            this.$refs.vehicleTreeSelect.setSelectList(
              this.formExtend.forms.vehicleIdList
            );
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取区域下拉
    async getAreaList() {
      try {
        let res = await getAreaDataTree();
        if (res.result && Array.isArray(res.result)) {
          this.areaList = res.result;
          this.$nextTick(() => {
            this.$refs.areaTreeSelect.setSelectList([
              Number(this.$route.query.areaIdList)
            ]);
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 车辆选择的回调
    selVehicle(val) {
      this.formExtend.forms.vehicleIdList = [];
      if (val.length) {
        this.formExtend.forms.vehicleIdList = val.map(v => {
          return v.id;
        });
      }
    },
    // 区域选择的回调
    selArea(val) {
      this.formExtend.forms.areaIdList = [];
      if (val.length) {
        this.formExtend.forms.areaIdList = val.map(v => {
          return v.id;
        });
      }
    },
    // 请求列表数据
    getTableData() {
      try {
        return new Promise((resolve, reject) => {
          if (!this.timeRange) {
            this.$message.warning("开始时间与结束时间不能为空！");
            reject();
          }
          if (this.validataTime() && this.validataStayLength()) {
            FetchVehicleInOutDetailByPage(this.mergeObj())
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else {
            this.tableLoading = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    // 整合查询数据
    mergeObj() {
      if (this.timeRange) {
        this.formExtend.forms.beginTime = this.timeRange[0];
        this.formExtend.forms.endTime = this.timeRange[1];
      } else {
        this.formExtend.forms.beginTime = "";
        this.formExtend.forms.endTime = "";
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 导出excel 表格
    handleExport() {
      if (this.validataTime()) {
        let params = this.mergeObj();
        this.exportData(params);
      }
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportVehicleInOutDetail(params).then(res => {
          // 导出
          exportXlsx(res, `区域进出统计明细表.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 重置
    handleResetForm() {
      this.timeRange = [
        moment()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ];
      this.$refs.vehicleTreeSelect.multipleRemoveAll();
      this.$refs.areaTreeSelect.multipleRemoveAll();
      this.formExtend.forms.vehicleIdList = [];
      this.formExtend.forms.areaIdList = [];
    },

    //导出
    handleExportClick() {
      let param = "";
      if (this.timeRange !== null && this.timeRange !== "") {
        param += "&beginTime=" + this.timeRange[0];
        param += "&endTime=" + this.timeRange[1];
        param += "&vehicleIdList=" + this.formExtend.forms.vehicleIdList;
        param += "&areaIdList=" + this.formExtend.forms.areaIdList;
        param += "&transType=" + this.formExtend.forms.transType;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "开始时间与结束时间不能为空！",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}
/deep/ .el-table__fixed-body-wrapper {
  height: calc(100% - 36px) !important;
  top: 36px !important;
}
</style>
